import { Component, Input , Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-bin-view',
  templateUrl: './bin-view.component.html',
  styleUrls: ['./bin-view.component.scss']
})
export class BinViewComponent {

  @Input() binCols=[];
  @Input() binData=[];
  @Input() totalRecordBins: number=0;
  @Input() noBinsFindOrLoadingText: string = '';
  @Output() onPageChange: EventEmitter<any> = new EventEmitter();
  @Output() onColumnSearch: EventEmitter<any> = new EventEmitter();
  @Output() onEditCapacity: EventEmitter<any> = new EventEmitter();
  @Output() onBinSelect: EventEmitter<any> = new EventEmitter();
  pageNumber: number = 1;
  pageSize: number = 15;
  rowsPerPage = [15, 30, 50, 100];

  constructor() { }


  getBinData(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    const obj ={pageNumber: this.pageNumber,pageSize: this.pageSize}
    this.onPageChange.emit(obj);
    
}

onBinFilter(value, field) {
  const binSearchColumns = field == "binNo"? "number": field == "qty"? "qty": field == "binType"? "bintype": field;
  const binSearchValue = value;
  const obj ={cols: binSearchColumns,value: binSearchValue};
  this.onColumnSearch.emit(obj);
}

onBinRowSelect(rowData){
  this.onBinSelect.emit(rowData);
}

openEditCapacity(rowData){
  this.onEditCapacity.emit(rowData);
}

}
